var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGraph = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.595,
    height: 58.963,
    viewBox: "0 0 48.595 58.963",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7032c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5136d1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_top_1637397_000000",
    transform: "translate(-2.21 -5.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5692",
    "data-name": "Path 5692",
    d: "M49.366,47.34H33.055a1.445,1.445,0,0,0-1.224,1.595V78.887H50.59V48.935a1.448,1.448,0,0,0-1.224-1.595Z",
    transform: "translate(-14.703 -14.357)",
    fill: "#859096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-color-svg",
    "data-name": "Path 5693",
    d: "M51.887,12.035l-5.762-.911L43.606,5.475A1.59,1.59,0,0,0,42.15,4.6a1.425,1.425,0,0,0-1.274.851L38.238,11l-5.762.757a1.517,1.517,0,0,0-.88,2.578l4.124,4.124-1.062,5.731a1.52,1.52,0,0,0,2.184,1.639l5.186-2.638.12.06,5.005,2.7a1.5,1.5,0,0,0,2.213-1.547l-.911-5.762,4.215-4.035a1.485,1.485,0,0,0-.784-2.574Z",
    transform: "translate(-15.646 0.972)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5696",
    "data-name": "Path 5696",
    d: "M12.568,63.305H3.434A1.445,1.445,0,0,0,2.21,64.9V84.374H13.794V64.9a1.446,1.446,0,0,0-1.226-1.595Z",
    transform: "translate(0 -19.844)",
    fill: "#859096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5697",
    "data-name": "Path 5697",
    d: "M86.059,68.625H76.923A1.445,1.445,0,0,0,75.7,70.22V86.2H87.283V70.22a1.447,1.447,0,0,0-1.224-1.595Z",
    transform: "translate(-36.477 -21.672)",
    fill: "#859096"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGraph, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/graph.9138624d.svg";
export { ForwardRef as ReactComponent };